export const buildLogConcentrationTicks = (values: unknown[]) => {
  const positive = values.map(Number).filter((value) => Number.isFinite(value) && value > 0);
  if (positive.length === 0) return { tickvals: [] as number[], ticktext: [] as string[] };
  const first = Math.floor(Math.log10(Math.min(...positive)));
  const last = Math.ceil(Math.log10(Math.max(...positive)));
  const tickvals = Array.from({ length: last - first + 1 }, (_, index) => 10 ** (first + index));
  const ticktext = tickvals.map((value) => value >= 0.000001 && value < 1000000
    ? value.toLocaleString('en-GB', { useGrouping: false, maximumFractionDigits: 12 })
    : value.toExponential(0));
  return { tickvals, ticktext };
};
